import React from 'react';

import './styles.css';

const SearchInput = ({onSearchChange, placeholder}) => (
  <input
    className="SearchInput"
    type="text"
    placeholder={placeholder}
    onChange={onSearchChange}
  />
);

export default SearchInput;
